import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useDataAttributes } from '@bluebeam/react-hooks';
import { useRect } from '@reach/rect';
import { useTooltipTrigger } from '@react-aria/tooltip';
import { mergeProps } from '@react-aria/utils';
import { useTooltipTriggerState } from '@react-stately/tooltip';
import * as React from 'react';
import { useRef } from 'react';
import TooltipContent from './TooltipContent';
const Tooltip = ({ children, className, disabled, label, isInfo, placement = 'bottom', zIndex = 50, ...rest }) => {
    const delay = 250;
    const state = useTooltipTriggerState({ delay, isDisabled: disabled });
    const triggerRef = useRef(null);
    const dataAttributes = useDataAttributes(rest);
    const { triggerProps, tooltipProps } = useTooltipTrigger({ delay, isDisabled: disabled }, state, triggerRef);
    const triggerRect = useRect(triggerRef, { observe: Boolean(triggerRef.current) });
    if (!React.isValidElement(children)) {
        throw new Error('Expected children to be a React Element');
    }
    return (_jsxs(_Fragment, { children: [React.cloneElement(children, {
                ...mergeProps(children.props, triggerProps, { ref: triggerRef }),
            }), triggerRect && (_jsx(TooltipContent, { state: state, ...tooltipProps, isInfo: isInfo, triggerRect: triggerRect, placement: placement, className: className, zIndex: zIndex, ...dataAttributes, children: label }))] }));
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map